import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { authUser } from '@/constants/common'
import { MenuAppConfigKey, MenuItemType } from '@/types/menuTypes'

import { focusIds } from './focus'
import { icons } from './icons'
import { paths } from './paths'

export const MainMenuNames = {
  SEARCH: 'SEARCH',
  HOME: 'HOME',
  CLASSIC_HOME: 'CLASSIC_HOME',
  SPECIAL_HOME: 'SPECIAL',
  HOME_GRID: 'HOME_GRID',
  SELECTED: 'SELECTED',
  FAVORITES: 'FAVORITES',
  SPORTS: 'SPORTS',
  CATALOGUE: 'CATALOGUE',
  CALENDAR: 'CALENDAR',
  PROFILE: 'PROFILE',
  FOCUS_PAGE: 'FOCUS',
  OFFERS: 'OFFERS',
}

export const SettingsMenuNames = {
  DEVELOPER: 'DEVELOPER',
  YOUTUBE: 'YOUTUBE',
  SMART_PREVIEW: 'SMART_PREVIEW',
  REGION: 'SETTINGS_REGION',
  ACCOUNT: 'SETTINGS_ACCOUNT',
  IMPRINT: 'SETTINGS_IMPRINT',
  DATA_PRIVACY: 'SETTINGS_DATA_PRIVACY',
  ANALYTICS_COOKIE: 'SETTINGS_ANALYTICS_COOKIE',
  COOKIE_BANNER: 'SETTINGS_COOKIE_BANNER',
  TERMS_CONDITIONS: 'SETTINGS_TERMS_CONDITIONS',
  HLS_ADS_PLAYER: 'Hls Ads Player',
}

export const mainMenuProfilePageItems = [
  {
    name: MainMenuNames.PROFILE,
    path: `${paths.SETTINGS}`,
    id: focusIds.SETTINGS_MENU,
    iconDirectPath: icons.navigation.profile,
  },
  {
    name: MainMenuNames.SEARCH,
    path: paths.SEARCH,
    id: focusIds.SEARCH,
    iconDirectPath: icons.navigation.search,
  },
]

export const mainMenuHomePageItems = [
  {
    name: MainMenuNames.SPECIAL_HOME,
    path: paths.SPECIAL_HOME,
    id: focusIds.SPECIAL_HOME,
    iconDirectPath: icons.navigation.specialHome,
    appConfigKey: MenuAppConfigKey.SPECIAL_HOME,
  },
  {
    name: MainMenuNames.HOME,
    path: paths.HOME,
    id: focusIds.HOME,
    iconDirectPath: icons.navigation.house,
    appConfigKey: MenuAppConfigKey.HOME,
  },
  {
    name: MainMenuNames.CLASSIC_HOME,
    path: paths.CLASSIC_HOME,
    id: focusIds.CLASSIC_HOME,
    iconDirectPath: icons.navigation.house,
    appConfigKey: MenuAppConfigKey.HOME,
  },
  {
    name: MainMenuNames.HOME_GRID,
    path: paths.HOME_GRID,
    id: focusIds.HOME_GRID,
    iconDirectPath: icons.navigation.house,
    hidden: true,
  },
]

export const mainMenuDefaultPageItems: Array<MenuItemType> = [
  {
    name: MainMenuNames.SPORTS,
    path: paths.SPORTS,
    id: focusIds.SPORTS,
    iconDirectPath: icons.navigation.sportsIcon,
  },
  {
    name: MainMenuNames.FOCUS_PAGE,
    path: paths.FOCUS_PAGE,
    id: focusIds.FOCUS_PAGE,
    iconDirectPath: icons.navigation.broadcasters,
  },
  {
    name: MainMenuNames.CATALOGUE,
    path: paths.CATALOGUE,
    id: focusIds.CATALOGUE,
    iconDirectPath: icons.navigation.sportsIcon,
    hasSubmenu: true,
  },
  {
    name: MainMenuNames.SELECTED,
    path: paths.SELECTED_PAGE,
    id: focusIds.PAGE,
    iconDirectPath: icons.navigation.selected,
    appConfigKey: MenuAppConfigKey.SELECTED,
  },
  {
    name: MainMenuNames.FAVORITES,
    path: paths.FAVORITES,
    id: focusIds.FAVORITES,
    iconDirectPath: icons.navigation.favorites,
  },
  {
    name: MainMenuNames.CALENDAR,
    path: paths.CALENDAR,
    id: focusIds.CALENDAR,
    iconDirectPath: icons.navigation.calendar,
  },
]

export const settingsMenuItems = [
  {
    name: SettingsMenuNames.ACCOUNT,
    path: `${paths.SETTINGS}/${paths.SETTINGS_ACCOUNT}`,
    id: focusIds.SETTINGS_ACCOUNT,
    iconDirectPath: icons.navigation.profile,
  },
  {
    name: SettingsMenuNames.REGION,
    path: `${paths.SETTINGS}/${paths.SETTINGS_REGION}`,
    id: focusIds.SETTINGS_REGION,
    iconDirectPath: icons.navigation.profile,
    visible: !isDevMode && authUser.REGISTERED,
  },
  {
    name: SettingsMenuNames.COOKIE_BANNER,
    path: `${paths.SETTINGS}/${paths.SETTINGS_COOKIE_BANNER}`,
    id: focusIds.USERCENTRICS,
    iconDirectPath: icons.navigation.cookie,
  },
  {
    name: SettingsMenuNames.DEVELOPER,
    path: `${paths.SETTINGS}/${paths.SETTINGS_DEVELOPER}`,
    id: focusIds.SETTINGS_DEVELOPER,
    iconDirectPath: icons.navigation.gavel,
    hidden: !isDevMode,
  },
  {
    name: SettingsMenuNames.SMART_PREVIEW,
    path: paths.SETTINGS_SMART_PREVIEW,
    id: focusIds.SETTINGS_SMART_PREVIEW,
    iconDirectPath: icons.navigation.gavel,
    hidden: !isDevMode,
  },
  {
    name: SettingsMenuNames.IMPRINT,
    path: `${paths.SETTINGS}/${paths.SETTINGS_IMPRINT}`,
    id: focusIds.SETTINGS_IMPRINT,
    iconDirectPath: icons.navigation.gavel,
  },
  {
    name: SettingsMenuNames.DATA_PRIVACY,
    path: `${paths.SETTINGS}/${paths.SETTINGS_DATA_PRIVACY}`,
    id: focusIds.SETTINGS_DATA_PRIVACY,
    iconDirectPath: icons.navigation.lockAlt,
  },
  {
    name: SettingsMenuNames.TERMS_CONDITIONS,
    path: `${paths.SETTINGS}/${paths.SETTINGS_TERMS_CONDITIONS}`,
    id: focusIds.SETTINGS_TERMS_CONDITIONS,
    iconDirectPath: icons.navigation.termsConditions,
  },
  {
    name: SettingsMenuNames.HLS_ADS_PLAYER,
    path: `${paths.SETTINGS}/${paths.SETTINGS_HLS_ADS_PLAYER}`,
    id: focusIds.SETTINGS_HLS_ADS_PLAYER,
    iconDirectPath: icons.navigation.broadcasters,
    hidden: !isDevMode,
  },
]

export const offersMenuItem = {
  name: MainMenuNames.OFFERS,
  path: paths.OFFERS,
  id: focusIds.OFFERS,
  iconDirectPath: icons.navigation.idCard,
}
